import React, { useEffect, useState } from 'react';
import activityService, { ActivityEntry } from '../../services/activityService';
import '../../assets/styles/Workflow.css';

interface ProjectActivityFeedProps {
  projectId: number;
}

const ACTION_ICON: Record<string, string> = {
  project_created: '🆕',
  project_updated: '✎',
  members_updated: '👥',
  stage_changed: '➡️',
  project_rejected: '⛔',
  subtask_created: '➕',
  subtask_status_changed: '🔄',
  file_uploaded: '📤',
  file_appended: '📎',
  file_replaced: '🔁',
  file_deleted: '🗑️',
  payment_toggled: '💳',
  project_sent: '📧',
};

const POLL_INTERVAL_MS = 20000;

const ProjectActivityFeed: React.FC<ProjectActivityFeedProps> = ({ projectId }) => {
  const [entries, setEntries] = useState<ActivityEntry[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const load = () => {
      activityService.listActivity(projectId)
        .then((data) => { if (active) { setEntries(data); setError(null); } })
        .catch((e: any) => { if (active) setError((e?.response?.data?.message || e?.response?.message) || 'Failed to load activity'); });
    };
    load();
    const interval = setInterval(load, POLL_INTERVAL_MS);
    return () => { active = false; clearInterval(interval); };
  }, [projectId]);

  return (
    <div className="wf-chat-full">
      <div className="wf-chatlog">
        {error && <div className="wf-chat-error">{error}</div>}
        {entries.length === 0 ? (
          <div className="wf-chat-empty">
            <div className="wf-chat-empty-icon">🕘</div>
            <div className="wf-chat-empty-title">No activity yet</div>
            <div className="wf-chat-empty-sub">Every change on this project - status, files, subtasks, payment - shows up here.</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {entries.map((entry) => (
              <div
                key={entry.id}
                style={{
                  display: 'flex',
                  gap: 10,
                  padding: '10px 4px',
                  borderBottom: '1px solid #f1f2f4',
                  fontSize: 13,
                }}
              >
                <span style={{ fontSize: 15, lineHeight: '20px' }}>{ACTION_ICON[entry.action] || '•'}</span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div>{entry.description}</div>
                  <div style={{ fontSize: 11.5, color: '#9ca3af', marginTop: 2 }}>
                    {entry.actor_name || 'System'} · {new Date(entry.created_at).toLocaleString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectActivityFeed;
